import React from 'react';
import { motion } from 'framer-motion';
import { Avatar } from '../common/Avatar';
import { SectionLink } from './SectionLink';
import { formatDuration } from '../../utils/format';
import { teamLabel } from '../../utils/teams';
import type { RankedRow } from '../CallsInsightHub/useCallsInsightHub';
const medals: Record<number, {
  badge: string;
  bar: string;
  row: string;
}> = {
  1: {
    badge: 'bg-gold text-on-accent',
    bar: 'bg-gold',
    row: 'bg-gold-soft'
  },
  2: {
    badge: 'bg-silver text-on-accent',
    bar: 'bg-silver',
    row: 'bg-silver-soft'
  },
  3: {
    badge: 'bg-bronze text-on-accent',
    bar: 'bg-bronze',
    row: 'bg-bronze-soft'
  }
};
interface TopPerformersProps {
  rows: RankedRow[];
  scopeLabel: string;
  onSelect: (id: string) => void;
  onViewAll: () => void;
}
export function TopPerformers({
  rows,
  scopeLabel,
  onSelect,
  onViewAll
}: TopPerformersProps) {
  const top = rows.slice(0, 3);
  const max = Math.max(1, ...top.map(r => r.stats.talkSeconds));
  return <section aria-labelledby="top-performers-heading" className="flex flex-col rounded-2xl border border-line bg-surface p-6 shadow-card" data-id="element-347" data-mp="tmaa2gd4lxh">
      <div className="mb-5 flex items-start justify-between gap-3" data-id="element-348" data-mp="5tqofltst4kj">
        <div data-id="element-349" data-mp="3n12n2h4mz5xb">
          <h2 id="top-performers-heading" className="text-base font-semibold text-ink" data-id="element-350" data-mp="3n1m66160w0cx">
            Top performers
          </h2>
          <p className="mt-0.5 text-sm text-muted" data-id="element-351" data-mp="3s0fj9shedpck">By time on calls, {scopeLabel}</p>
        </div>
        <SectionLink label="View leaderboard" onClick={onViewAll} data-id="element-352" data-mp="jkm4bi2pslxm" />
      </div>

      {top.length === 0 ? <p className="py-8 text-center text-sm text-muted" data-id="element-353" data-mp="oif7s3cmv1u7">No users in this team.</p> : <ul className="flex flex-1 flex-col justify-between gap-3" data-id="element-354" data-mp="9u0v70pezz0g">
          {top.map(({
        agent,
        stats,
        rank
      }) => {
        const m = medals[rank];
        return <li key={agent.id} data-id="element-355" data-mp="12i6gppoals1c">
                <button type="button" onClick={() => onSelect(agent.id)} aria-label={`Rank ${rank}, ${agent.name}. View details`} className={`w-full rounded-xl px-4 py-3.5 text-left transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:shadow-card active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent ${m.row}`} data-id="element-356" data-mp="12gvevveequcv">
                  <div className="flex items-center gap-3" data-id="element-357" data-mp="13546w42z3d02">
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${m.badge}`} data-id="element-358" data-mp="y6j725rmuvc5">{rank}</span>
                    <Avatar name={agent.name} size="md" data-id="element-359" data-mp="tejbepiliold" />
                    <div className="min-w-0 flex-1" data-id="element-360" data-mp="oghr619foj8b">
                      <p className="truncate font-semibold text-ink" data-id="element-361" data-mp="oh9buh1hswjt">{agent.name}</p>
                      <p className="truncate text-xs text-muted" data-id="element-362" data-mp="kgz717pfsc6j">
                        {teamLabel(agent.team)} · Ext. {agent.extension}
                      </p>
                    </div>
                    <p className="shrink-0 font-display text-xl font-bold text-ink" data-id="element-363" data-mp="aijdky2xsqtv">{formatDuration(stats.talkSeconds)}</p>
                  </div>
                  <div className="ml-10 mt-3 h-1.5 overflow-hidden rounded-full bg-surface" aria-hidden data-id="element-364" data-mp="2r3ofovwqlmxo">
                    <motion.div className={`h-full w-full origin-left rounded-full ${m.bar}`} initial={{
                scaleX: 0
              }} animate={{
                scaleX: stats.talkSeconds / max
              }} transition={{
                duration: 0.3,
                ease: [0.22, 1, 0.36, 1],
                delay: 0.25 + rank * 0.06
              }} data-id="element-365" data-mp="2w2rjkd0zdn42" />
                  </div>
                </button>
              </li>;
      })}
        </ul>}
    </section>;
}